
import React from 'react';
import { FormPage } from '@/types/form';
import ReviewPage from './ReviewPage';
import FormContentRenderer from './FormContentRenderer';
import { useElementGroups } from './useElementGroups';

interface FormContentSectionProps {
  isReviewMode: boolean;
  isPage3: boolean;
  currentPageConfig: FormPage;
  documentUrls: string[];
}

const FormContentSection: React.FC<FormContentSectionProps> = ({
  isReviewMode,
  isPage3,
  currentPageConfig,
  documentUrls
}) => {
  // Get element groups for Page 3
  const elementGroups = useElementGroups(isPage3, currentPageConfig.elements);
  
  // Filter out the document_link element if there are no document URLs
  const filteredPageConfig = {
    ...currentPageConfig,
    elements: currentPageConfig.elements.filter(element => {
      // If element is document_link and there are no document URLs, hide it
      if (element.type === 'document_link' && (!documentUrls || documentUrls.length === 0)) {
        return false;
      }
      return true;
    })
  };
  
  if (isReviewMode) {
    return <ReviewPage />;
  }
  
  return (
    <FormContentRenderer
      isPage3={isPage3}
      currentPageConfig={filteredPageConfig}
      elementGroups={elementGroups}
      documentUrls={documentUrls}
    />
  );
};

export default FormContentSection;
